<template>
  <app-modal
    ref="modal"
    v-bind="$attrs"
    class="modal-container"
    content-class="modal-large"
    title="KDDI GPU Cloud向けVNコネクト設定"
  >
    <template v-if="isLoaded" v-slot:body="{ cancel }">
      <cross-validation-observer
        :initial-values="{
          routeAggregationAddressList:
            form.cloudVnConnectCommon!.routeAggregationAddressList &&
            form.cloudVnConnectCommon!.routeAggregationAddressList.length > 0
              ? form.cloudVnConnectCommon!.routeAggregationAddressList
              : [''],
        }"
        v-slot="{ handleSubmit }"
        as="div"
      >
        <v-form novalidate @submit.stop.prevent="handleSubmit(submit)">
          <v-card-text class="pa-0">
            <div class="modal-body">
              <v-container>
                <!-- クラウド設定 -->
                <v-row>
                  <v-col>
                    <h3>クラウド設定</h3>
                  </v-col>
                </v-row>
                <!-- KDDI GPU Cloudご契約番号 -->
                <v-row>
                  <v-col>
                    <app-badge
                      item="KDDI GPU Cloudご契約番号"
                      :msg="$filter.message('info_m_number')"
                      :is-info="isAdd"
                      :isRequired="isAdd"
                    />
                    <template v-if="isAdd">
                      <validation-provider
                        name="mNumber"
                        label="KDDI GPU Cloudご契約番号"
                        v-model="
                          (form as CloudVnGpuPost).cloudVnConnectCommon!.mNumber
                        "
                        :rules="{
                          required: true,
                          is_m_number: true,
                          max: { length: 9 },
                        }"
                        v-slot="{ componentField, errorMessage, meta }"
                      >
                        <app-form-input
                          v-bind="componentField"
                          :field-meta="meta"
                          :error-messages="errorMessage"
                        />
                      </validation-provider>
                    </template>
                    <app-form-input
                      v-else
                      :value="cloudVnGpuDetail!.cloudVnConnectCommon.mNumber"
                      disabled
                    />
                  </v-col>
                </v-row>
                <!--ロケーション-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="ロケーション"
                      :is-info="false"
                      :isRequired="isAdd"
                    />
                    <template v-if="isAdd">
                      <validation-provider
                        name="location"
                        label="ロケーション"
                        v-model="form.cloudVnConnectCommon!.location"
                        :rules="{ required: true }"
                        v-slot="{ componentField, errorMessage, meta }"
                      >
                        <app-select
                          :items="locationOptions"
                          item-title="text"
                          item-value="value"
                          v-bind="componentField"
                          :field-meta="meta"
                          :error-messages="errorMessage"
                        />
                      </validation-provider>
                    </template>
                    <app-form-input
                      v-else
                      :value="
                        $filter.enumTo(
                          cloudVnGpuDetail!.cloudVnConnectCommon.location,
                          'location'
                        )
                      "
                      disabled
                    />
                  </v-col>
                </v-row>
                <!--接続先仮想ネットワーク(VPN/VN)名-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="接続先仮想ネットワーク(VPN/VN)名"
                      :is-info="false"
                      :isRequired="isAdd"
                    />
                    <template v-if="isAdd">
                      <validation-provider
                        name="selectedVpnVn"
                        label="接続先仮想ネットワーク(VPN/VN)名"
                        v-model="selectedVpnVn"
                        :rules="{ required: true }"
                        v-slot="{ componentField, errorMessage, meta }"
                      >
                        <app-select-search
                          :items="vpnVnCodeSelectList"
                          item-title="text"
                          item-value="value"
                          v-bind="componentField"
                          :field-meta="meta"
                          :error-messages="errorMessage"
                        />
                      </validation-provider>
                    </template>
                    <!--変更の場合、変更不可-->
                    <app-form-input v-else :value="vpnVnName" disabled />
                  </v-col>
                </v-row>
                <!-- KBIテナントコード -->
                <v-row>
                  <v-col>
                    <app-badge
                      item="KBIテナントコード"
                      :msg="$filter.message('info_kbi_tenant_code')"
                      :is-info="isAdd"
                      :isRequired="isAdd"
                    />
                    <template v-if="isAdd">
                      <validation-provider
                        name="kbiTenantCode"
                        label="KBIテナントコード"
                        v-model="
                          (form as CloudVnGpuPost).cloudVnConnectCommon!
                            .kbiTenantCode
                        "
                        :rules="{
                          required: true,
                          is_kbi_tenant_code: true,
                          max: { length: 100 },
                        }"
                        v-slot="{ componentField, errorMessage, meta }"
                      >
                        <app-form-input
                          v-bind="componentField"
                          :field-meta="meta"
                          :error-messages="errorMessage"
                        />
                      </validation-provider>
                    </template>
                    <app-form-input
                      v-else
                      :value="
                        cloudVnGpuDetail!.cloudVnConnectCommon.kbiTenantCode
                      "
                      disabled
                    />
                  </v-col>
                </v-row>
                <!-- VNコネクト設定 -->
                <v-row>
                  <v-col>
                    <h3>VNコネクト設定</h3>
                  </v-col>
                </v-row>
                <!--品目-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="品目"
                      :is-info="false"
                      :isRequired="true"
                    />
                    <validation-provider
                      name="bandwidth"
                      label="品目"
                      v-model="form.cloudVnConnectCommon!.bandwidth"
                      :rules="{
                        required: true,
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-select-search
                        :items="bandwidthSelectList"
                        item-title="text"
                        item-value="value"
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--VNコネクト名(Act)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="VNコネクト名(Act)"
                      :msg="
                        $filter.message('info_max_length', {
                          maxLength: '20',
                        })
                      "
                    />
                    <validation-provider
                      name="vnConnectNameAct"
                      label="VNコネクト名(Act)"
                      v-model="form.cloudVnConnectAct!.vnConnectName"
                      :rules="{
                        required: true,
                        max: { length: 20 },
                        alpha_num_zenkaku: true,
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--VNコネクト名(Sby)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="VNコネクト名(Sby)"
                      :msg="
                        $filter.message('info_max_length', {
                          maxLength: '20',
                        })
                      "
                    />
                    <validation-provider
                      name="vnConnectNameSby"
                      label="VNコネクト名(Sby)"
                      v-model="form.cloudVnConnectSby!.vnConnectName"
                      :rules="{
                        required: true,
                        max: { length: 20 },
                        alpha_num_zenkaku: true,
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>

                <!-- ルーティング情報(共通) -->
                <v-row>
                  <v-col>
                    <h3>ルーティング情報(共通)</h3>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <app-label-group label="ルーティング種別" value="BGP4" />
                  </v-col>
                </v-row>
                <!-- AS番号 -->
                <v-row>
                  <v-col>
                    <app-badge
                      item="AS番号"
                      :is-info="false"
                      :isRequired="false"
                    />
                    <app-form-input
                      :value="
                        (form as CloudVnGpuPost).cloudVnConnectCommon!.asNumber
                      "
                      disabled
                    />
                  </v-col>
                </v-row>
                <!-- Maximum Prefix(Act) -->
                <v-row>
                  <v-col>
                    <app-badge
                      item="Maximum Prefix"
                      :is-info="false"
                      :isRequired="true"
                    />
                    <validation-provider
                      name="maximumPrefix"
                      label="Maximum Prefix(Act)"
                      v-model="form.cloudVnConnectCommon!.maximumPrefix"
                      :rules="{ required: true }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-select
                        :items="maximumPrefixSelectList"
                        item-title="text"
                        item-value="value"
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>

                <!-- ルーティング情報(Act) -->
                <v-row>
                  <v-col>
                    <h3>ルーティング情報(Act)</h3>
                  </v-col>
                </v-row>
                <!--WANアドレス(Act)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="WANアドレス"
                      :msg="
                        '・' +
                        $filter.message('info_cidr_ip_v4_with_subnet_2', {
                          subnet: '30',
                        }) +
                        '\n' +
                        '・' +
                        $filter.message('info_cidr_subnet', {
                          subnet: '30',
                        })
                      "
                      :is-info="isAdd"
                      :is-required="isAdd"
                    />
                    <validation-provider
                      name="wanAddressAct"
                      label="WANアドレス(Act)"
                      v-model="
                        (form as CloudVnGpuPost).cloudVnConnectAct!.wanAddress
                      "
                      :rules="{
                        required: true,
                        is_ip_subnet: { min: 30, max: 30 },
                        is_not_current_ip: true,
                        is_not_loopback_ip: true,
                        is_not_multicast_ip: true,
                        is_not_class_e_ip: true,
                        is_not_broadcast_ip: true,
                        is_not_network_ip: true,
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        :disabled="!isAdd"
                        :placeholder="
                          !isAdd
                            ? null
                            : $filter.message(
                                'placeholder_ip_address_with_subnet30'
                              )
                        "
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--ピアIPアドレス(Act)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="ピアIPアドレス"
                      :msg="
                        $filter.message('info_ip_address_v4_2', { host: '2' })
                      "
                      :is-info="isAdd"
                      :is-required="isAdd"
                    />
                    <validation-provider
                      name="peerIpAddressAct"
                      label="ピアIPアドレス(Act)"
                      v-model="
                        (form as CloudVnGpuPost).cloudVnConnectAct!
                          .peerIpAddress
                      "
                      :rules="{
                        required: true,
                        is_ipv4: true,
                        cross_wan_address_within_range: {
                          wan: (form as CloudVnGpuPost).cloudVnConnectAct!
                            .wanAddress,
                        },
                        cross_wan_peer_consecutive: {
                          wan: (form as CloudVnGpuPost).cloudVnConnectAct!
                            .wanAddress,
                        },
                        is_not_loopback_ip: true,
                        is_not_multicast_ip: true,
                        is_not_class_e_ip: true,
                        is_not_broadcast_ip: {
                          range: (form as CloudVnGpuPost).cloudVnConnectAct!
                            .wanAddress,
                        },
                        is_not_network_ip: {
                          range: (form as CloudVnGpuPost).cloudVnConnectAct!
                            .wanAddress,
                        },
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        :disabled="!isAdd"
                        :placeholder="
                          !isAdd
                            ? null
                            : $filter.message('placeholder_ip_address_3', {
                                host: '2',
                              })
                        "
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--Local Preference(Act)-->
                <v-row>
                  <v-col>
                    <app-label-group label="Local Preference">
                      <template #value>
                        <app-form-input
                          :value="
                            $filter.enumTo('HIGH_PRIORITY', 'localPreference')
                          "
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
                <!--MED(Act)-->
                <v-row>
                  <v-col>
                    <app-label-group label="MED">
                      <template #value>
                        <app-form-input
                          :value="$filter.enumTo('LOW_PRIORITY', 'med')"
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>

                <!-- ルーティング情報(Sby) -->
                <v-row>
                  <v-col>
                    <h3>ルーティング情報(Sby)</h3>
                  </v-col>
                </v-row>
                <!--WANアドレス(Sby)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="WANアドレス"
                      :msg="
                        '・' +
                        $filter.message('info_cidr_ip_v4_with_subnet_2', {
                          subnet: '30',
                        }) +
                        '\n' +
                        '・' +
                        $filter.message('info_cidr_subnet', {
                          subnet: '30',
                        })
                      "
                      :is-info="isAdd"
                      :is-required="isAdd"
                    />
                    <validation-provider
                      name="wanAddressSby"
                      label="WANアドレス(Sby)"
                      v-model="
                        (form as CloudVnGpuPost).cloudVnConnectSby!.wanAddress
                      "
                      :rules="{
                        required: true,
                        is_ip_subnet: { min: 30, max: 30 },
                        is_not_current_ip: true,
                        is_not_loopback_ip: true,
                        is_not_multicast_ip: true,
                        is_not_class_e_ip: true,
                        is_not_broadcast_ip: true,
                        is_not_network_ip: true,
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        :disabled="!isAdd"
                        :placeholder="
                          !isAdd
                            ? null
                            : $filter.message(
                                'placeholder_ip_address_with_subnet30'
                              )
                        "
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--ピアIPアドレス(Sby)-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="ピアIPアドレス"
                      :msg="
                        $filter.message('info_ip_address_v4_2', { host: '2' })
                      "
                      :is-info="isAdd"
                      :is-required="isAdd"
                    />
                    <validation-provider
                      name="peerIpAddressSby"
                      label="ピアIPアドレス(Sby)"
                      v-model="
                        (form as CloudVnGpuPost).cloudVnConnectSby!
                          .peerIpAddress
                      "
                      :rules="{
                        required: true,
                        is_ipv4: true,
                        cross_wan_address_within_range: {
                          wan: (form as CloudVnGpuPost).cloudVnConnectSby!
                            .wanAddress,
                        },
                        cross_wan_peer_consecutive: {
                          wan: (form as CloudVnGpuPost).cloudVnConnectSby!
                            .wanAddress,
                        },
                        is_not_loopback_ip: true,
                        is_not_multicast_ip: true,
                        is_not_class_e_ip: true,
                        is_not_broadcast_ip: {
                          range: (form as CloudVnGpuPost).cloudVnConnectSby!
                            .wanAddress,
                        },
                        is_not_network_ip: {
                          range: (form as CloudVnGpuPost).cloudVnConnectSby!
                            .wanAddress,
                        },
                      }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        :disabled="!isAdd"
                        :placeholder="
                          !isAdd
                            ? null
                            : $filter.message('placeholder_ip_address_3', {
                                host: '2',
                              })
                        "
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
                <!--Local Preference(Sby)-->
                <v-row>
                  <v-col>
                    <app-label-group label="Local Preference">
                      <template #value>
                        <app-form-input
                          :value="
                            $filter.enumTo('LOW_PRIORITY', 'localPreference')
                          "
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>
                <!--MED(Sby)-->
                <v-row>
                  <v-col>
                    <app-label-group label="MED">
                      <template #value>
                        <app-form-input
                          :value="$filter.enumTo('HIGH_PRIORITY', 'med')"
                          disabled
                        />
                      </template>
                    </app-label-group>
                  </v-col>
                </v-row>

                <!-- カスタム経路集約情報 -->
                <v-row>
                  <v-col>
                    <h3>カスタム経路集約情報</h3>
                  </v-col>
                </v-row>
                <!--経路集約-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="経路集約"
                      :isRequired="false"
                      :isInfo="false"
                    />
                    <v-radio-group
                      v-model="form.cloudVnConnectCommon!.routeAggregation"
                      hide-details
                      inline
                    >
                      <v-radio
                        v-for="(routeOption, index) in routeOptions"
                        :key="`${routeOption.text + index}`"
                        :label="routeOption.text"
                        :value="routeOption.value"
                      />
                    </v-radio-group>
                  </v-col>
                </v-row>
                <!--経路集約アドレス-->
                <v-row
                  v-if="form.cloudVnConnectCommon!.routeAggregation !== 'OFF'"
                >
                  <v-col>
                    <app-badge
                      item="経路集約アドレス"
                      :is-required="
                        form.cloudVnConnectCommon!.routeAggregation === 'CUSTOM'
                      "
                      :is-info="
                        form.cloudVnConnectCommon!.routeAggregation === 'CUSTOM'
                      "
                      :msg="$filter.message('info_routing_address')"
                    />
                    <template
                      v-if="
                        form.cloudVnConnectCommon!.routeAggregation === 'ON'
                      "
                    >
                      <span class="ml-3">0.0.0.0/0</span>
                    </template>
                    <template
                      v-if="
                        form.cloudVnConnectCommon!.routeAggregation === 'CUSTOM'
                      "
                    >
                      <validation-array
                        name="routeAggregationAddressList"
                        v-slot="{ fields, push, remove }"
                      >
                        <template
                          v-for="(item, index) in fields"
                          :key="item.key"
                        >
                          <v-row class="ga-2">
                            <validation-provider
                              :name="`routingIp_${item.key}`"
                              label="経路集約アドレス"
                              v-model="
                                form.cloudVnConnectCommon!
                                  .routeAggregationAddressList![index]
                              "
                              :rules="{
                                required: true,
                                is_ip_subnet: { min: 1, max: 30 },
                                is_network_address: true,
                                is_not_default_root: true,
                                duplicate: { list: routingAddressList(index) },
                              }"
                              v-slot="{ componentField, errorMessage, meta }"
                            >
                              <app-form-input
                                class="ml-1"
                                :placeholder="
                                  $filter.message(
                                    'placeholder_ip_address_with_subnet24'
                                  )
                                "
                                v-bind="componentField"
                                :field-meta="meta"
                                :error-messages="errorMessage"
                              />
                              <v-btn
                                icon="$mdiMinus"
                                size="small"
                                variant="outlined"
                                class="rounded-sm ml-2 mr-3"
                                @click="removeRouteAddress(index, remove)"
                              />
                            </validation-provider>
                          </v-row>
                        </template>
                        <!--経路集約アドレス追加-CUSTOMのみ表示-->
                        <v-row justify="end">
                          <v-btn
                            icon="$mdiPlus"
                            size="small"
                            variant="outlined"
                            class="rounded-sm ml-2 mr-3"
                            :disabled="currentLength >= 100"
                            @click="addRouteAddress(push)"
                          />
                        </v-row>
                      </validation-array>
                    </template>
                  </v-col>
                </v-row>

                <!--備考-->
                <v-row>
                  <v-col>
                    <app-badge
                      item="備考"
                      :msg="
                        $filter.message('info_max_length', { maxLength: '20' })
                      "
                      :is-info="true"
                      :isRequired="false"
                    />
                    <validation-provider
                      name="description"
                      label="備考"
                      v-model="form.cloudVnConnectCommon!.description"
                      :rules="{ max: { length: 20 } }"
                      v-slot="{ componentField, errorMessage, meta }"
                    >
                      <app-form-input
                        v-bind="componentField"
                        :field-meta="meta"
                        :error-messages="errorMessage"
                      />
                    </validation-provider>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-list-item class="w-100 pa-1">
              <template v-slot:append>
                <v-btn type="submit" color="primary" variant="flat">{{
                  isAdd ? "追加" : "変更"
                }}</v-btn>
                <v-btn color="primary" variant="outlined" @click="cancel"
                  >キャンセル
                </v-btn>
              </template>
            </v-list-item>
          </v-card-actions>
        </v-form>
      </cross-validation-observer>
    </template>
  </app-modal>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { VueFinalModal } from "vue-final-modal";
import type {
  BandWidth,
  RouteAggregation,
  VpnVnCode as CloudVpnVnCode,
} from "@/apis/CloudVnMsApi";
import type { CloudLine } from "@/apis/CloudLineApi";
import cloneDeep from "lodash/cloneDeep";
import type {
  CloudVnGpuCommon,
  CloudVnGpuDetail,
  CloudVnGpuPost,
  CloudVnGpuPut,
} from "@/apis/CloudVnGpuApi";
import type { VpnVnCode } from "@/apis/InformationApi";
import MultiCloudGpuVnConnectionConfirm from "@/modals/multicloud/gpu/MultiCloudGpuVnConnectionConfirm.vue";
import type { UpperLimitEntity } from "@/apis/UpperLimitApi";

export default defineComponent({
  name: "MultiCloudGpuVnLineEdit",
  props: {
    /** クラウド回線SEQ */
    cloudLineSeq: {
      type: String as PropType<string>,
      required: true,
    },
    // 変更の場合用
    cloudVnGpuDetail: {
      type: Object as PropType<CloudVnGpuDetail>,
      default: undefined,
    },
    // 追加の場合用
    cloudVnGpuKeyId: {
      type: String as PropType<string>,
      default: undefined,
    },
    // 設定可能帯域
    remainingBandwidth: {
      type: Number as PropType<number>,
      required: true,
    },
  },
  data() {
    // 新規/更新のformデータを作成
    const form:
      | (CloudVnGpuPost & {})
      | (CloudVnGpuPut & {
          cloudVnConnectCommon: Pick<CloudVnGpuCommon, "location">;
          bandItem: string | null;
        }) = (() => {
      if (this.cloudVnGpuDetail) {
        // 変更
        const cloudVnGpuDetailCopy = cloneDeep(this.cloudVnGpuDetail);
        // 経路集約アドレスを数値昇順でソート
        if (
          cloudVnGpuDetailCopy.cloudVnConnectCommon &&
          Array.isArray(
            cloudVnGpuDetailCopy.cloudVnConnectCommon
              .routeAggregationAddressList
          )
        ) {
          cloudVnGpuDetailCopy.cloudVnConnectCommon.routeAggregationAddressList =
            cloudVnGpuDetailCopy.cloudVnConnectCommon.routeAggregationAddressList.sortIpAddress();
        }
        const form: CloudVnGpuPut & {
          cloudVnConnectCommon: Pick<CloudVnGpuCommon, "location">;
          bandItem: string | null;
        } = {
          cloudVnConnectCommon: cloudVnGpuDetailCopy.cloudVnConnectCommon,
          cloudVnConnectAct: cloudVnGpuDetailCopy.cloudVnConnectAct,
          cloudVnConnectSby: cloudVnGpuDetailCopy.cloudVnConnectSby,
          cloudVnGpuKeyId: cloudVnGpuDetailCopy.cloudVnGpuKeyId,
          // 変更の場合、名前でラベルを表示するので、初期値をブランクにする
          bandItem: null,
        };
        return form;
      } else {
        // 追加
        const form: CloudVnGpuPost & {} = {
          cloudVnConnectCommon: {
            type: "BARE_METAL",
            bandwidthType: "PF",
            routeAggregation: "OFF",
            routeAggregationAddressList: null,
            location: "WEST_JAPAN",
            maximumPrefix: 100,
            asNumber: 2516,
          } as unknown as CloudVnGpuPost["cloudVnConnectCommon"],
          cloudVnConnectAct: {} as CloudVnGpuPost["cloudVnConnectAct"],
          cloudVnConnectSby: {} as CloudVnGpuPost["cloudVnConnectSby"],
          cloudVnGpuKeyId: this.cloudVnGpuKeyId!,
        };
        return form;
      }
    })();

    return {
      form: form,
      isLoaded: false,
      vpnVnCodeList: [] as VpnVnCode[],
      cloudLineMaxBandwidth: {} as CloudLine["bandwidth"],
      selectedVpnVn: null as null | CloudVpnVnCode,
      bandwidthOptions: [
        { text: "1Gbps", value: { value: 1, unit: "GBPS" } },
        { text: "2Gbps", value: { value: 2, unit: "GBPS" } },
        { text: "3Gbps", value: { value: 3, unit: "GBPS" } },
        { text: "4Gbps", value: { value: 4, unit: "GBPS" } },
        { text: "5Gbps", value: { value: 5, unit: "GBPS" } },
        { text: "6Gbps", value: { value: 6, unit: "GBPS" } },
        { text: "7Gbps", value: { value: 7, unit: "GBPS" } },
        { text: "8Gbps", value: { value: 8, unit: "GBPS" } },
        { text: "9Gbps", value: { value: 9, unit: "GBPS" } },
        { text: "10Gbps", value: { value: 10, unit: "GBPS" } },
        { text: "20Gbps", value: { value: 20, unit: "GBPS" } },
        { text: "30Gbps", value: { value: 30, unit: "GBPS" } },
        { text: "40Gbps", value: { value: 40, unit: "GBPS" } },
        { text: "50Gbps", value: { value: 50, unit: "GBPS" } },
        { text: "60Gbps", value: { value: 60, unit: "GBPS" } },
        { text: "70Gbps", value: { value: 70, unit: "GBPS" } },
        { text: "80Gbps", value: { value: 80, unit: "GBPS" } },
        { text: "90Gbps", value: { value: 90, unit: "GBPS" } },
        { text: "100Gbps", value: { value: 100, unit: "GBPS" } },
      ] as { text: string; value: BandWidth }[],
      routeOptions: [
        { value: "ON", text: "ON" },
        { value: "OFF", text: "OFF" },
        { value: "CUSTOM", text: "CUSTOM" },
      ],
      locationOptions: [{ value: "WEST_JAPAN", text: "西日本" }],
      /** Maximum Prefix上限値(変更の場合用) */
      maximumPrefixLimit: null as UpperLimitEntity | null,
      /** 1G超VNコネクト */
      vnConnects1G: null as UpperLimitEntity | undefined | null,
      /** 追加・変更モーダルの残り帯域数 */
      editRemainingBandwidth: 0 as number,
    };
  },
  computed: {
    currentLength(): number {
      return this.form.cloudVnConnectCommon!.routeAggregationAddressList
        ? this.form.cloudVnConnectCommon!.routeAggregationAddressList.length
        : 0;
    },
    /** true: 新規, false: 変更 */
    isAdd(): boolean {
      return !this.cloudVnGpuDetail;
    },
    vpnVnCodeSelectList(): {
      value: string;
      text: string;
    }[] {
      return this.vpnVnCodeList.map((v) => {
        if (v.vnName) {
          return {
            value: v.vpnVnCode,
            text: v.vnName + ":" + v.vpnVnCode + "(L3)",
          };
        } else {
          return { value: v.vpnVnCode, text: v.vpnVnCode };
        }
      });
    },
    /** 品目の選択肢 */
    bandwidthSelectList(): { text: string; value: BandWidth }[] {
      // クラウド帯域値
      const limit1 = this.$filter.bandwidthToBps(this.cloudLineMaxBandwidth);

      // 設定上限値
      const limit2 = this.$filter.bandwidthToBps({
        value: this.vnConnects1G!.upperLimit,
        unit: "GBPS",
      });

      // 選択肢内容を処理する
      const bandwidthOptions = this.bandwidthOptions.filter((v) => {
        const bps = this.$filter.bandwidthToBps(v.value)!;
        return (
          bps <= limit1! && bps <= limit2! && bps <= this.editRemainingBandwidth
        );
      });

      return bandwidthOptions;
    },
    /** Maximum Prefixの選択肢 */
    maximumPrefixSelectList(): { text: string; value: number }[] {
      if (this.isAdd) {
        return [{ value: 100, text: "100" }];
      } else {
        return [
          { value: 100, text: "100" },
          { value: 200, text: "200" },
          { value: 300, text: "300" },
          { value: 400, text: "400" },
          { value: 500, text: "500" },
          { value: 1000, text: "1000" },
          { value: 1500, text: "1500" },
          { value: 2000, text: "2000" },
        ].filter((v) => v.value <= this.maximumPrefixLimit!.upperLimit);
      }
    },

    vpnVnName(): string {
      if (
        this.cloudVnGpuDetail!.cloudVnConnectCommon.vpnVnCode.startsWith("D")
      ) {
        return (
          this.cloudVnGpuDetail!.cloudVnConnectCommon.vnName +
          ":" +
          this.cloudVnGpuDetail!.cloudVnConnectCommon.vpnVnCode +
          "(L3)"
        );
      } else {
        return this.cloudVnGpuDetail!.cloudVnConnectCommon.vpnVnCode;
      }
    },
    /** 経路集約アドレスの重複チェック用リスト作成 */
    routingAddressList() {
      return (index: number) => {
        return this.form.cloudVnConnectCommon!.routeAggregationAddressList
          ? this.form.cloudVnConnectCommon!.routeAggregationAddressList.filter(
              (_, num) => num !== index
            )
          : [];
      };
    },
  },
  watch: {
    /** 経路集約がCUSTOMに変更されて初期値が存在しない場合は初期化 */
    "form.cloudVnConnectCommon.routeAggregation"(newValue: RouteAggregation) {
      if (
        newValue === "CUSTOM" &&
        (!this.form.cloudVnConnectCommon!.routeAggregationAddressList ||
          this.form.cloudVnConnectCommon!.routeAggregationAddressList.length ===
            0)
      ) {
        this.form.cloudVnConnectCommon!.routeAggregationAddressList = [""];
      }
    },
    /** 帯域が変更されたら、既存値をクリアする */
    "form.bandItem"() {
      if (this.form.cloudVnConnectCommon!.bandwidth) {
        this.form.cloudVnConnectCommon!.bandwidth = { value: 0, unit: "MBPS" };
      }
    },
  },
  async mounted() {
    this.maxBandwidth();
    await this.load();
    this.isLoaded = true;
  },
  methods: {
    async load() {
      // 回線情報に紐づくクラウド回線情報を取得APIを呼び出す
      const lines = (await this.$api.cloudLine.getCloudLines()).lineList;
      const cloudLines = lines.flatMap(
        (v: { cloudLineList: any }) => v.cloudLineList
      );
      // クラウド回線の帯域最大値(品目の上限値制御用)
      this.cloudLineMaxBandwidth = cloudLines.find(
        (v: { cloudLineSeq: string }) => v.cloudLineSeq === this.cloudLineSeq
      )!.bandwidth;

      // 1G超VNコネクトの値を取得（品目の上限値制御用）
      const getVnConnects1G = await this.$api.upperLimit.getUpperLimitLine({
        upperLimitLineManageUnit: "MULTI_CLOUD",
        cloudLineSeq: this.cloudLineSeq,
      });
      this.vnConnects1G = getVnConnects1G.cloudLine!.upperLimitList!.find(
        (v: { upperLimitItemName: string }) =>
          v.upperLimitItemName === "1G超VNコネクト"
      );

      if (this.isAdd) {
        this.vpnVnCodeList = (await this.$api.information.getVpnVnCodeList())
          .filter(
            (v: { vnType: string | null }) =>
              v.vnType === "L3" || v.vnType === null
          )
          .sortBy(["vpnVnCode", "asc"]);
      } else {
        // maximumPrefixの上限値を取得
        this.maximumPrefixLimit = (
          await this.$api.upperLimit.getUpperLimitLine({
            upperLimitLineManageUnit: "MULTI_CLOUD",
            cloudLineSeq: this.cloudLineSeq,
            wnumber: this.cloudVnGpuDetail!.cloudVnConnectAct.wnumber,
          })
        ).cloudLine!.upperLimitList!.find(
          (v: { upperLimitItemName: string }) =>
            v.upperLimitItemName === "BGP4の最大経路数"
        )!;
      }
    },

    /** 最大帯域 */
    maxBandwidth() {
      if (!this.isAdd) {
        this.editRemainingBandwidth =
          this.remainingBandwidth +
          this.$filter.bandwidthToBps(
            this.cloudVnGpuDetail!.cloudVnConnectCommon.bandwidth
          )!;
      } else {
        this.editRemainingBandwidth = this.remainingBandwidth;
      }
      return this.editRemainingBandwidth;
    },

    /** 経路集約アドレス削除 */
    removeRouteAddress(index: number, remove: (idx: number) => void) {
      const list = this.form.cloudVnConnectCommon!.routeAggregationAddressList!;
      if (list.length > 1) {
        list.splice(index, 1);
        // ValidationにFieldを削除することを伝える
        remove(index);
      } else {
        this.form.cloudVnConnectCommon!.routeAggregationAddressList = [""];
      }
    },

    /** 経路集約アドレス追加 */
    addRouteAddress(push: (item: any) => void) {
      const addItem = "";
      this.form.cloudVnConnectCommon!.routeAggregationAddressList = [
        ...this.form.cloudVnConnectCommon!.routeAggregationAddressList!,
        addItem,
      ];
      // ValidationにFieldを追加することを伝える
      push(addItem);
    },
    async submit() {
      const form = {
        ...this.form,
        cloudVnConnectCommon: {
          ...this.form.cloudVnConnectCommon,
          routeAggregationAddressList:
            this.form.cloudVnConnectCommon!.routeAggregation === "ON"
              ? []
              : this.form.cloudVnConnectCommon!.routeAggregation === "OFF"
                ? null
                : this.form.cloudVnConnectCommon!.routeAggregationAddressList,
        },
      } as
        | (CloudVnGpuPost & {
            bandItem: string | null;
          })
        | (CloudVnGpuPut & {
            bandItem: string | null;
          });
      if (this.isAdd) {
        // 追加の場合
        // 確認モーダルの表示
        let displayVnName;
        const vnSbyName = form.cloudVnConnectSby?.vnConnectName;
        (form as CloudVnGpuPost).cloudVnConnectCommon!.vpnVnCode =
          this.selectedVpnVn!;
        displayVnName = this.vpnVnCodeList.find(
          (v) =>
            v.vpnVnCode ===
            (form as CloudVnGpuPost).cloudVnConnectCommon!.vpnVnCode
        )!.vnName;
        await this.$modal.show(MultiCloudGpuVnConnectionConfirm, {
          cloudVnGpuDetail: {
            cloudVnConnectCommon: {
              ...form.cloudVnConnectCommon,
              vnName: displayVnName,
              routingType: "BGP4",
            },
            cloudVnConnectAct: {
              ...form.cloudVnConnectAct,
              localPreference: "HIGH_PRIORITY",
              med: "LOW_PRIORITY",
            },
            cloudVnConnectSby: vnSbyName
              ? {
                  ...form.cloudVnConnectSby,
                  localPreference: "LOW_PRIORITY",
                  med: "HIGH_PRIORITY",
                }
              : null,
          },
          displayType: "A",
        });
        await this.$api.cloudVnGpu.postVnConnect(
          this.cloudLineSeq,
          form as CloudVnGpuPost
        );
        (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
      } else {
        // 変更の場合
        // 確認モーダルの表示
        await this.$modal.show(MultiCloudGpuVnConnectionConfirm, {
          cloudVnGpuDetail: {
            ...form,
          },
          displayType: "M",
        });
        // 変更のみの場合
        await this.$api.cloudVnGpu.putVnConnect(
          this.cloudLineSeq,
          this.cloudVnGpuDetail!.cloudVnConnectAct.wnumber,
          form as CloudVnGpuPut
        );
        (this.$refs.modal as typeof VueFinalModal & { ok: () => void }).ok();
      }
    },
  },
});
</script>
